// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"064c1b10","298":"d882c41a","498":"f280d607","666":"a2c3fb44","780":"20faeb70","791":"77912c4d","828":"c50b52fa","932":"9694bc9b","985":"ea0ee8b2"}[chunkId] + ".chunk.js";
};